import {registerNode, Rect} from '@topology/core'
import { ScrollList } from './scrollList'
export function register() {
  registerNode('ScrollList', ScrollList, null, function (node) {
    node.iconRect = new Rect(node.rect.x, node.rect.y, node.rect.width, node.rect.height)
    node.fullIconRect = node.rect
  }, null)
}
// # sourceMappingURL=register.js.map



// WEBPACK FOOTER //
// ./src/components/topologyDiagram/scrollList/register.js